import { FormBase } from 'core/components';

export default class FacilityOrderTemplateItemNewFlowCalculationModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'templateQuantity',
                    label: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.ML',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.ML_PLACEHOLDER',
                    type: 'integer',
                },
                {
                    name: 'mlph',
                    label: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.ML',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.ML_PLACEHOLDER',
                    rules: ['min:0'],
                    type: 'number',
                },
                {
                    name: 'frequency',
                    label: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.FREQ',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.FREQ_PLACEHOLDER',
                    rules: ['min:0'],
                    type: 'number',
                },
                {
                    name: 'itemMls',
                    label: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.TOTAL_ML',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.TOTAL_ML_PLACEHOLDER',
                    rules: ['min:0'],
                    type: 'number',
                },
                {
                    name: 'itemCals',
                    label: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.TOTAL_CALS',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_ITEM.FACILITY_ORDER_TEMPLATE_ITEM_NEW_FLOW_CALCULATION_MODAL.TOTAL_CALSL_PLACEHOLDER',
                    rules: ['min:0'],
                    type: 'number',
                },
            ],
        };
    }
}
